import { Colors } from '@src/colors';
import styled, { css } from 'styled-components';
import { Label } from './Label.styled';

export const Button = styled.button<{ variant: 'contained' | 'outlined' }>`
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    padding: 0 24px;
    cursor: pointer;

    ${(props) =>
        props.variant === 'contained'
            ? css`
                  background: ${Colors.ownerYellow};
                  color: ${Colors.textPrimary};
                  border: none;
                  &:hover {
                      background: ${Colors.guestYellow_40};
                  }
                  &:active {
                      background: ${Colors.guestYellow};
                  }
              `
            : css`
                  background: ${Colors.white};
                  border: 1.5px solid ${Colors.midnight};
                  color: ${Colors.midnight};
                  &:hover {
                      background: ${Colors.midnight2};
                  }
                  &:active {
                      background: ${Colors.midnight4};
                  }
              `}

    ${Label} {
        font-family: Public Sans;
        font-size: 16px;
        font-weight: 800;
        line-height: 24px;
        letter-spacing: 0.75px;
        text-align: center;
        cursor: pointer;
    }

    &:disabled {
        background: ${Colors.grayEight};
        border: 1.5px solid ${Colors.duskTwo};
        cursor: none;
        ${Label} {
            color: ${Colors.duskTwo};
        }
    }
    //styling from Oscar.scss https://static-assets.boise.vacasa.com/css/oscar.css
    .btn-v-primary {
        border: none;
        color: ${Colors.dusk};
        background-color: ${Colors.guestYellow};
        text-align: center;
        font-size: 1em;
        line-height: 1.5em;
        padding: 0.5em 1em;
        transition: all 0.2s;
        &:hover,
        .is-hovered {
            background-color: ${Colors.guestYellow};
        }
        &:active,
        &:focus,
        .is-active,
        .is-focused {
            outline: ${Colors.lake} auto 4px;
        }

        .is-disabled {
            opacity: 0.5;
            pointer-events: none;
        }
        .is-selected {
            background-color: ${Colors.guestYellow};
            box-shadow: inset 0 1px 4px 0 ${Colors.awareness};
        }
    }

    .btn-v-utility {
        background: white;
        border: 1px solid #b3c2c8;
        color: #003349;
        font-size: 1em;
        line-height: 1.5em;
        padding: 0.5em 1em;
        transition: all 0.2s;
        &:hover,
        .is-hovered {
            background-color: ${Colors.midnight4};
        }
        &:active,
        &:focus,
        .is-active,
        .is-focused {
            outline: ${Colors.lake} auto 4px;
        }
        .is-disabled {
            opacity: 0.5;
            pointer-events: none;
        }
        .is-selected {
            background-color: ${Colors.midnight4};
            border: 1px solid ${Colors.grayThree};
            box-shadow: inset 0 1px 4px 0 ${Colors.grayFive};
            border-radius: 2px;
        }
    }
`;
